import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { IProgram } from "@pbm/programs/contracts/program";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { CursorPaginated } from "@types";
import { IFilteredColumn } from "@funcional/react-table-ui";

export interface ProgramsArgsFilterInput {
  code?: string[];
  type?: string[];
  establishmentIdentity?: any;
}
interface UseProgramsOptions {
  before?: string;
  after?: string;
  first?: number;
  last?: number;
  filter?: ProgramsArgsFilterInput;
  gridFilters?: IFilteredColumn[];
}

export function usePrograms(options: UseProgramsOptions | undefined = {}) {
  const { request } = usePbm2Url();
  options.first = options.first || 9999;
  if (options.gridFilters) {
    const filter: ProgramsArgsFilterInput = options.filter || {};
    options.gridFilters.forEach((filteredColumn: any) => {
      if (filteredColumn.id === "code") filter.code = [filteredColumn.value];
      if (filteredColumn.id === "type") filter.type = [filteredColumn.value];
      if (filteredColumn.id === "after") options.after = filteredColumn.value;
    });

    options.filter = filter;
  }
  return useQuery("programs:" + JSON.stringify(options), async () => {
    const { Rules_programs } = await request(
      gql`
        query programs(
          $before: String
          $after: String
          $first: Int
          $last: Int
          $filter: Rules_ProgramsArgsFilterInput
        ) {
          Rules_programs(
            before: $before
            after: $after
            first: $first
            last: $last
            filter: $filter
          ) {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              pageCount
              totalCount
            }
            edges {
              cursor
              node {
                code
                name
                type
                createdAt
                updatedAt
                deletedAt
                effectiveSince
                effectiveUntil
                registrationPeriodStart
                registrationPeriodEnd
                establishmentIdentity

                registrationPolicy {
                  id
                  description
                }
                priority
                enableButtonPriority
              }
            }
          }
        }
      `,
      options
    );
    // Processar os dados e aplicar a ordenação manualmente
    const sortedPrograms = Rules_programs.edges
      .map((edge: any) => edge.node)
      .sort((a: any, b: any) => {
        if (a.establishmentIdentity !== b.establishmentIdentity) {
          // Ordenar por establishmentIdentity
          return a.establishmentIdentity.localeCompare(b.establishmentIdentity);
        } else {
          // Ordenar por priority
          if (a.priority === undefined && b.priority === undefined) {
            return 0;
          }
          if (a.priority === undefined) {
            return 1;
          }
          if (b.priority === undefined) {
            return -1;
          }
          return a.priority - b.priority;
        }
      });

    return {
      pageInfo: Rules_programs.pageInfo,
      edges: sortedPrograms.map((node: any) => ({ node, cursor: "" })),
    };
  });
}
